<style lang="less">
@import "../less/common.less";
// @import "./landscape.less";
@import "../less/portrait.less";
</style>
<template>
  <div class="main portrait">
    <div class="login_img2">
      <img src="../image/login-r.png"
           alt="..." />
    </div>
    <div class="login_img3">
      <img src="../image/login-l.png"
           alt="..." />
    </div>
    <el-row :gutter="20">
      <!-- <div class="title-login">LOGO</div> 待定 -->
      <el-col :span="9">
        <el-form :model="ruleForm"
                 :rules="rules"
                 ref="ruleForm"
                 class="demo-ruleForm">
          <el-form-item label>
            <div class="tips">欢迎登录</div>
          </el-form-item>
          <el-form-item label
                        prop="name">
            <img src="../image/phone.png"
                 alt="..." />
            <el-input v-model.trim="ruleForm.name"
                      type="text"
                      maxlength="11"
                      placeholder="输入账户号码"
                      autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label
                        prop="password"
                        class="password">
            <img src="../image/pass.png"
                 alt="..." />
            <el-input name="loginpwd"
                      :type="pwdType"
                      v-model.trim="ruleForm.password"
                      maxlength="16"
                      placeholder="输入账户密码"
                      autocomplete="off"></el-input>
            <img v-if="pwdType!='password'"
                 class="show-password"
                 src="../image/show-password.png"
                 @click="showPassword(true)"
                 alt="..." />
            <img v-else
                 class="show-password"
                 src="../image/hidden-password.png"
                 @click="showPassword(false)"
                 alt="..." />
          </el-form-item>
          <el-form-item label
                        class="code">
            <el-checkbox v-model="ruleForm.isRemember">记住密码</el-checkbox>
          </el-form-item>
          <el-form-item class="check-login">
            <el-button class="but-login but-confirm"
                       type="primary"
                       :loading="true"
                       v-if="loadingBtn">登录中</el-button>
            <el-button class="but-login but-confirm"
                       type="primary"
                       @click="loginConfirm('ruleForm')"
                       v-else>登录</el-button>
          </el-form-item>
        </el-form>
      </el-col>

    </el-row>
    <FooterC></FooterC>
  </div>
</template>
<script>
import $ from "jquery";
import userApi from "@/api/api-user";
import { Message } from "element-ui";
import FooterC from "@/components/modal/FooterC";
import screenfull from 'screenfull'
import common from "@/libs/common";
import {
  localToken
} from '@/libs/util';
export default {
  name: "register",
  data () {
    var numReg = /^[0-9]*$/;
    var numRe = new RegExp(numReg);
    var numReg2 = /^(?![A-Z]+$)(?![a-z]+$)(?!\d+$)(?![\W_]+$)\S{6,16}$/;
    var numRe2 = new RegExp(numReg2);
    var validatePhone = (rule, value, callback) => {
      if (value == null) {
        callback(new Error("请输入账户号码"));
      }
      // else if (!numRe.test(value) || value.length != 11) {
      //   callback(new Error("请输入正确的手机号"));
      // } 
      else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入账户密码"));
      } else if (value.length < 6) {
        callback(new Error("密码最短6位,最长16位"));
      }
      // else if (!numRe.test(value)) {
      //   callback(
      //     new Error("密码须含有小写字母、大写字母、数字、特殊符号两种以上")
      //   );
      // }
      // else if (!numRe2.test(value)) {
      //   callback(
      //     new Error("密码须含有小写字母、大写字母、数字、特殊符号两种以上")
      //   );
      // } 
      else {
        callback();
      }
    };
    return {
      Verification: true, //通过v-show控制显示获取还是倒计时
      timer: 60, //定义初始时间为60s
      loadingBtn: false,
      equipment: "mb",
      pwdType: "password",
      ruleForm: {
        name: null,
        password: "",
        isRemember: false
      },
      rules: {
        name: [{ validator: validatePhone, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }]
      },
      fullscreen: false
    };
  },
  components: {
    FooterC
  },
  methods: {
    // 获取记住密码信息
    loadAccountInfo () {
      let that = this
      let tenantID = localToken.getTenant()
      let rememberInfo = localToken.getRememberInfo()
      rememberInfo = JSON.parse(rememberInfo)
      // 如果没有账号信息
      if (Boolean(rememberInfo) == false) {
        that.ruleForm.name = null
        that.ruleForm.password = ""
        that.ruleForm.isRemember = false
        return false
      } else {
        // 检测到账号信息！现在开始预填写！
        that.ruleForm.name = rememberInfo.name
        that.ruleForm.password = rememberInfo.password
        that.ruleForm.isRemember = rememberInfo.isRemember
      }
    },
    // 进入全屏
    handleFullScreen () {
      let that = this
      common.fullScreen(that.fullscreen)
      // let element = document.documentElement;
      // if (this.fullscreen) {
      //   if (document.exitFullscreen) {
      //     document.exitFullscreen();
      //   } else if (document.webkitCancelFullScreen) {
      //     document.webkitCancelFullScreen();
      //   } else if (document.mozCancelFullScreen) {
      //     document.mozCancelFullScreen();
      //   } else if (document.msExitFullscreen) {
      //     document.msExitFullscreen();
      //   }
      // } else {
      //   if (element.requestFullscreen) {
      //     element.requestFullscreen();
      //   } else if (element.webkitRequestFullScreen) {
      //     element.webkitRequestFullScreen();
      //   } else if (element.mozRequestFullScreen) {
      //     element.mozRequestFullScreen();
      //   } else if (element.msRequestFullscreen) {
      //     // IE11
      //     element.msRequestFullscreen();
      //   }
      // }
      // this.fullscreen = !this.fullscreen;
    },
    // 登录
    loginConfirm (formName) {
      let that = this;
      that.loadingBtn = true;
      this.$refs[formName].validate(valid => {
        if (valid) {
          that.handleFullScreen()
          that.login().then(
            res => {
              if (typeof res.entity == "undefined" || res.entity == null) {
                that.loadingBtn = false;
              } else {
                that.$router.push({
                  path: "/main"
                });
                that.loadingBtn = false;
              }
            },
            err => {
              that.loadingBtn = false;
            }
          );
        } else {
          that.loadingBtn = false;
          return false;
        }
      });
    },
    // 登录
    login () {
      let that = this;
      return new Promise((resolve, reject) => {
        userApi
          .login(that.ruleForm)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 密码样式
    showPassword (flag) {
      if (!flag) {
        this.pwdType = "text";
      } else {
        this.pwdType = "password";
      }
    },
    getEquipment () {
      // 检测是否PC端
      let that = this;
      that.equipment = "mb";
      if (
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
      ) {
        that.equipment = "mb";
        /*window.location.href="你的手机版地址";*/
      } else {
        that.equipment = "pc";
      }
    }
  },
  mounted () {
    // this.getEquipment()
    // 读取账号信息，如果有rememberInfo的话，则说明该用户之前勾选了记住密码的功能，则需要自动填上账号密码
    this.loadAccountInfo()
  }
};
</script>



// WEBPACK FOOTER //
// src/view/login/login.vue